module.exports = __webpack_public_path__ + "img/zhuozheng.5b9820b8.jpg";